(function () {
    'use strict';

    angular.module("imApp").factory("deliveryTermService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1532,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1533,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
